import { I18n } from "@lingui/core";
import { t } from "@lingui/macro";
import { CreditorType } from "@gocardless/api/dashboard/types";
import { Color } from "@gocardless/flux-react";

import { SignUpAccountType } from "./SignUp";

import { isSandboxEnvironment } from "src/common/consts";

export const creditorTypeList = (i18n: I18n): Record<CreditorType, string> => ({
  [CreditorType.Charity]: i18n._(
    t({ id: "creditor_type.charity", message: "Charity/Non-profit" })
  ),
  [CreditorType.Individual]: i18n._(
    t({
      id: "creditor_type.individual_sole_trader",
      message: "Individual/Sole trader",
    })
  ),
  [CreditorType.Company]: i18n._(
    t({
      id: "creditor_type.limited_company",
      message: "Limited company/Corporation",
    })
  ),
  [CreditorType.Partnership]: i18n._(
    t({ id: "creditor_type.partnership", message: "Partnership" })
  ),
  [CreditorType.Trust]: i18n._(
    t({ id: "creditor_type.trust", message: "Trust" })
  ),
});

export enum MonthlyCollections {
  sm = "0 - 99",
  md = "100-999",
  lg = "10,000 - 99,999",
  xl = "100,000+",
}

export enum AnnualRevenue {
  sm = "0 - 500,000",
  md = "500,000 - 1,000,000",
  lg = "1,000,000 - 2,000,000",
  xl = "2,000,000 - 5,000,000",
  xxl = "5,000,000 - 10,000,000",
  xxxl = "10,000,000+",
}

export interface SignUpFormData {
  given_name: string;
  family_name: string;
  email: string;
  phone_number: string;
  organisation_name: string;
  geo: string;
  creditor_type: CreditorType;
  password: string;
  annual_revenue: string;
  monthly_collections: string;
  terms_and_conditions: boolean;
  recaptcha_token: string;
  language: string;
  account_type: SignUpAccountType;
  referral_code: string | null;
  is_payment_provider?: boolean;
  has_fsb_member_discount?: boolean;
}

export enum SignUpFormField {
  given_name = "given_name",
  family_name = "family_name",
  email = "email",
  phone_number = "phone_number",
  organisation_name = "organisation_name",
  geo = "geo",
  creditor_type = "creditor_type",
  password = "password",
  annual_revenue = "annual_revenue",
  monthly_collections = "monthly_collections",
  terms_and_conditions = "terms_and_conditions",
  recaptcha_token = "recaptcha_token",
  language = "language",
}

export enum SignUpAPIErrors {
  ValidationFailed = "validation_failed",
  ReCAPTCHAInvalid = "recaptcha_invalid_token",
}

export enum SignUpEvents {
  BusinessLocationChanged = "Merchant sign up  - Default business location has been changed",
}

export interface SignupFormData {
  organisation_name: string;
  geo: string;
  email: string;
  password: string;
}

export enum SignupFormField {
  organisation_name = "organisation_name",
  geo = "geo",
  email = "email",
  password = "password",
}

export enum TrackingErrorOrigin {
  server_side = "server-side",
  client_side = "client-side",
}

export const REFER_SHARE_LINK = "https://manage.gocardless.com/refer/";

export const COOKIES_LINK = "https://gocardless.com/legal/cookies/";

export const PRIVACY_POLICY_LINK = "https://gocardless.com/privacy/";

export const FEE_FREE_PROMO_TERMS_AND_CONDITIONS_LINK =
  "https://gocardless.com/g/no-fees-terms/";

export const REGULATORY_INFO = "https://gocardless.com/g/regulatory-info/";

export const FSB_MEMBER_DISCOUNT_TERMS_LINK =
  "https://gocardless.com/g/fsb-discount-terms/";

export const marketingBackgroundColor = isSandboxEnvironment
  ? Color.Greystone_DarkMatter
  : Color.Slate_700;
